import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Typography } from '@mui/material'
import type { FormattedAgentActivity } from '../utils'
import { getVerb } from '../utils'

interface ActivityVerbProps {
  readonly activity: FormattedAgentActivity
}

export const ActivityVerb: FC<ActivityVerbProps> = ({ activity }) => {
  const verb = getVerb(activity.toolName, activity.status).trim()

  return (
    <Typography component="span" sx={verbSx}>
      {verb}
    </Typography>
  )
}

const verbSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'text.primary',
  fontStyle: 'italic',
}
